

'use client';

import { Header } from '@/components/header';
import { Footer } from '@/components/footer';
import { ContactForm } from '@/components/contact/contact-form';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/components/providers/auth-provider';
import { Skeleton } from '@/components/ui/skeleton';
import type { Metadata } from 'next';

export default function ContactPage() {
    const { user, loading } = useAuth();

    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-1 container mx-auto px-4 py-8">
                <div className="max-w-2xl mx-auto">
                     <Card>
                        <CardHeader className="text-center">
                            <CardTitle className="text-3xl font-headline">Contact Us</CardTitle>
                            <CardDescription>
                                Have a question or feedback? Fill out the form below to get in touch with us.
                            </CardDescription>
                        </CardHeader>
                        <CardContent>
                             {loading ? (
                                <div className="space-y-4">
                                    <Skeleton className="h-10 w-full" />
                                    <Skeleton className="h-10 w-full" />
                                    <Skeleton className="h-32 w-full" />
                                    <Skeleton className="h-10 w-24 ml-auto" />
                                </div>
                             ) : (
                                <ContactForm user={user} />
                             )}
                        </CardContent>
                    </Card>
                </div>
            </main>
            <Footer />
        </div>
    );
}
